import variableApi from '@/api/variable';

export default {
  data () {
    return {
      selectedTags: []
    };
  },
  methods: {
    tagsChanged (tags) {
      this.selectedTags = tags;
      if (tags.length === 0) {
        this.taggedVariables = this.variablesMinimal;
      } else {
        variableApi.getTaggedMinimalVariables(this, tags.join(), true, '').then(data => {
          this.taggedVariables = data.body.sort((a, b) => {
            return a.label.localeCompare(b.label, undefined, {numeric: true, sensitivity: 'base'});
          });
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/layouts/variableSelectorUtils.js